import { Phone, Clock, AlertTriangle } from "lucide-react";

const assistanceData = [
  { name: "Porto Seguro", logo: "/logos/porto-seguro.png", phones: ["0800 727 0800"] },
  { name: "Allianz", logo: "/logos/allianz.png", phones: ["0800 130 700", "4090 1110"] },
  { name: "Zurich", logo: "/logos/zurich.png", phones: ["0800 729 1400", "0800 285 4141"] },
  { name: "SulAmérica", logo: "/logos/sulamerica.png", phones: ["0800 726 0101", "4004 2985"] },
  { name: "Bradesco Seguros", logo: "/logos/bradesco.png", phones: ["4004 2757", "0800 701 2757"] },
  { name: "Tokio Marine", logo: "/logos/tokio-marine.png", phones: ["0800 318 6546", "0300 338 6546"] },
  { name: "HDI", logo: "/logos/hdi.png", phones: ["3003 5390", "0800 434 4340"] },
  { name: "Itaú Seguros", logo: "/logos/itau.png", phones: ["0800 722 2437"] },
  { name: "Mapfre", logo: "/logos/mapfre.png", phones: ["4004 0900", "0800 775 0900"] },
  { name: "Generali", logo: "/logos/generali.png", phones: ["0800 880 2800"] },
  { name: "Mitsui Sumitomo", logo: "/logos/mitsui.png", phones: ["0800 707 7883"] },
  { name: "Yelum", logo: "/logos/yelum.png", phones: ["0800 701 4120"] },
  { name: "MAG", logo: "/logos/mag.png", phones: ["0800 602 2022"] },
  { name: "Azul Seguros", logo: "/logos/azul.png", phones: ["4004 3700", "0300 123 2985"] },
  { name: "Suhai", logo: "/logos/suhai.png", phones: ["0800 327 8424"] },
];

export default function Assistencia24h() {
  return (
    <div data-testid="assistencia-page">
      {/* Hero */}
      <section className="pt-20 bg-navy">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20 text-center">
          <div className="inline-flex items-center gap-2 bg-white/10 border border-white/20 rounded-full px-4 py-1.5 mb-5">
            <Phone className="h-4 w-4 text-gold" />
            <span className="text-sm text-white/80 font-medium">Assistência 24 Horas</span>
          </div>
          <h1 className="text-4xl sm:text-5xl font-heading font-bold text-white leading-tight mb-4">
            Assistência <span className="text-gold">24h</span> das Seguradoras
          </h1>
          <p className="text-base md:text-lg text-slate-300 max-w-2xl mx-auto">
            Telefones de emergência das seguradoras parceiras para solicitar guincho, chaveiro, socorro mecânico e suporte em acidentes.
          </p>
        </div>
      </section>

      {/* Alert */}
      <section className="bg-gold/5 border-b py-4">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-center gap-2">
          <AlertTriangle className="h-4 w-4 text-gold shrink-0" />
          <p className="text-sm text-slate-700">Em caso de <strong>emergência</strong>, ligue diretamente para a seguradora do seu seguro.</p>
        </div>
      </section>

      {/* Phone Directory */}
      <section className="py-16 md:py-24">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-4">
            {assistanceData.map((item, i) => (
              <div key={i} className="flex items-center justify-between bg-white border border-slate-200 rounded-xl p-5 hover:shadow-md transition-shadow" data-testid={`assistance-card-${i}`}>
                <div className="flex items-center gap-4">
                  <div className="w-10 h-10 rounded-lg bg-white border flex items-center justify-center shrink-0 overflow-hidden">
                    <img src={item.logo} alt={`Logo ${item.name} assistência 24h`} className="w-8 h-8 object-contain" />
                  </div>
                  <h3 className="font-heading font-semibold text-navy">{item.name}</h3>
                </div>
                <div className="flex flex-col sm:flex-row items-end sm:items-center gap-2">
                  {item.phones.map((phone, j) => (
                    <a key={j} href={`tel:${phone.replace(/\s/g, '')}`} className="inline-flex items-center gap-1.5 bg-slate-50 hover:bg-brand hover:text-white text-slate-700 text-sm font-medium px-3 py-1.5 rounded-lg border transition-colors" data-testid={`phone-${i}-${j}`}>
                      <Clock className="h-3 w-3" /> {phone}
                    </a>
                  ))}
                </div>
              </div>
            ))}
          </div>
          <p className="mt-8 text-center text-sm text-slate-400">
            Estes telefones permitem que os segurados solicitem assistência de emergência como guincho, chaveiro e suporte em acidentes.
          </p>
        </div>
      </section>
    </div>
  );
}
